import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Tak, {{name}}',
    confirmation_email:
      'Du modtager snart en bekræftelsesmail med dit ordrenummer på din e-mail fra vores teknologipartner {{provider_email}}',
    need_help: 'Brug for hjælp?',
  },
  labels: {
    order_number: 'Ordrenr.: {{number}}',
    order_number_short: '#{{number}}',
    today: 'I dag',
    was_prefix: 'var',
    restaurant: 'Restaurant',
    order_details: 'Ordredetaljer',
    your_details: 'Dine oplysninger',
    contact: 'Kontakt',
    payment: 'Betaling',
    payment_method: 'Betalingsmetode',
    delivery: 'Levering',
    delivery_details: 'Leveringsdetaljer',
    pickup_details: 'Afhentningsdetaljer',
    pickup_instruction: '📋 Oplys dit ordrenummer {{number}}, når du afhenter din ordre.',
    billing_info: 'Faktureringsoplysninger',
    order_summary: 'Ordreoversigt',
    help: 'Brug for hjælp? Kontakt os {{phone_number}}',
  },
  status: {
    canceled: 'Ordre annulleret',
    received: 'Ordre modtaget',
    confirmed: 'Ordre bekræftet!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Afhentning',
    [ORDER_METHODS.DELIVERY]: 'Levering',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Roomservice',
      [RoomServiceLocationType.TableService]: 'Bordservice',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(værelse #{{details}})',
    [RoomServiceLocationType.TableService]: '(bord #{{details}})',
  },
  rewards: {
    member: {
      pill_title: 'Optjente point',
      from_order: 'point fra denne ordre',
      total_balance: 'Samlet saldo',
      reward_value: 'Belønningsværdi',
      redeem_hint: '✓ Du kan indløse op til {{points}} point ({{amount}}) på din næste ordre',
      points_to_redeem: 'Du mangler kun {{points}} point for at indløse din belønning',
    },
    guest: {
      pill_title: 'Belønninger',
      earned_heading: 'Du har optjent <highlight>{{points}} point</highlight> på denne ordre',
      worth_on_next: 'Værd <strong>{{amount}}</strong> på din næste ordre',
      ready_to_claim: 'Klar til at hente',
      next_order_discount: 'Rabat på næste ordre',
      claim_cta: 'Hent dine {{points}} point – tilmeld dig gratis',
      claim_note: 'Tager 30 sekunder · dine point krediteres med det samme',
    },
  },
  buttons: {
    back_to_menu: 'Tilbage til menuen',
    back_to_checkout: 'Tilbage til checkout',
    contact_us: 'Kontakt os {{phone_number}}',
    try_again: 'Prøv igen',
  },
  loading: {
    processing_payment: 'Forlad ikke siden, mens vi behandler din betaling',
  },
  success_messages: {
    order_placed: {
      title: '✅ Ordre gennemført!',
      description: 'Din ordre er afgivet.',
    },
  },
  error_messages: {
    failed_to_load: 'Ordren kunne ikke indlæses. Prøv igen.',
    payment_failed: 'Betalingen mislykkedes. Prøv igen',
  },
  load_failed: {
    title: 'Vi kunne ikke indlæse din ordre',
    description:
      'Noget gik galt under indlæsningen af dine ordredetaljer. Prøv igen. Hvis det fortsætter, så kontakt support, så hjælper vi dig med det samme.',
  },
};
